/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // PhotoSwipe Logos Slideshow initialization
  function initLogosPhotoSwipe() {
    const sections = document.querySelectorAll('.section-slideshow--logos');

    sections.forEach(section => {
      if (!window.themePhotoswipe || !window.themePhotoswipe.PhotoSwipe) {
        if (window.theme && window.theme.assets && window.theme.assets.photoswipe) {
          const script = document.createElement('script');
          script.src = window.theme.assets.photoswipe;
          script.onload = () => setTimeout(() => initSectionPhotoSwipe(section), 100);
          document.head.appendChild(script);
          return;
        }
      }

      initSectionPhotoSwipe(section);
    });
  }

  function initSectionPhotoSwipe(section) {
    const blockSlides = [];

    const allBlocks = section.querySelectorAll('[data-pswp-block]');
    allBlocks.forEach((blockData, blockIndex) => {
      const blockTitle = blockData.getAttribute('data-block-title');
      const images = blockData.querySelectorAll('[data-pswp-img]');

      if (images.length > 0) {
        let blockHTML = `<div class="pswp__block-container">`;

        const logoImg = blockData.querySelector('[data-pswp-img="external_image"]');
        if (logoImg) {
          const logoSrc = logoImg.getAttribute('data-src');
          blockHTML += `
            <div class="pswp__logo-container">
              <img class="pswp__logo-image" src="${logoSrc}" alt="${blockTitle} - Logo">
            </div>
          `;
        }

        const screenshot1 = blockData.querySelector('[data-pswp-img="screenshot1"]');
        const screenshot2 = blockData.querySelector('[data-pswp-img="screenshot2"]');
        
        if (screenshot1 || screenshot2) {
          blockHTML += `<div class="pswp__screenshots-container">`;
          
          if (screenshot1) {
            const src1 = screenshot1.getAttribute('data-src');
            blockHTML += `<img class="pswp__screenshot-image" src="${src1}" alt="${blockTitle} - Screenshot 1">`;
          }
          
          if (screenshot2) {
            const src2 = screenshot2.getAttribute('data-src');
            blockHTML += `<img class="pswp__screenshot-image" src="${src2}" alt="${blockTitle} - Screenshot 2">`;
          }
          
          blockHTML += `</div>`;
        }
        
        blockHTML += `</div>`;
          
        blockSlides.push({
          html: blockHTML,
          w: 1200,
          h: 800,
          title: blockTitle
        });
      }
    });
    
    const triggers = section.querySelectorAll('[data-pswp-trigger]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        
        const blockIndex = parseInt(this.getAttribute('data-pswp-trigger'));
        
        if (blockSlides.length === 0) return;
        
        const pswpElement = section.querySelector('.pswp');
        const options = {
          index: blockIndex,
          bgOpacity: 0.8,
          showHideOpacity: true,
          loop: true,
          closeOnVerticalDrag: false,
          closeOnScroll: false,
          history: false,
          focus: false,
          showAnimationDuration: 333,
          hideAnimationDuration: 333
        };

        if (window.themePhotoswipe && window.themePhotoswipe.PhotoSwipe && window.themePhotoswipe.PhotoSwipeUI) {
          const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
          const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
          const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI, blockSlides, options);
          gallery.init();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initLogosPhotoSwipe);

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
